import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { TopUpOrder } from '../../service/class/TopUpOrder';
import { WithdrawOrderDetail } from '../../service/class/WithdrawOrderDetail';

// 借助 createSlice 创建 reducer、action
const WithdrawOrderDetailSlice = createSlice({
    name: 'withdrawOrderDetail',
    initialState: {
        value: new WithdrawOrderDetail(),
    },
    reducers: {
        setWithdrawOrderDetail: (state, action: PayloadAction<WithdrawOrderDetail>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setWithdrawOrderDetail } = WithdrawOrderDetailSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const withdrawOrderDetailSelector = (state: RootState) => state.withdrawOrderDetail.value;

// Reducer，真正执行修改 state 的纯函数
export default WithdrawOrderDetailSlice.reducer;
